import { interval } from 'rxjs';
import {
    filter,
    map,
    switchMap,
    withLatestFrom,
    takeUntil,
} from 'rxjs/operators';

const createResumePointIntervalStream = (
    playerPlaybackStoreUpdate$,
    resumePointsStoreUpdate$,
    scheduler
) =>
    resumePointsStoreUpdate$
        .pipe(
            filter(({ isEnabled }) => isEnabled),
            switchMap(({ updateIntervalMs }) =>
                interval(updateIntervalMs, scheduler)
                    .pipe(
                        takeUntil(resumePointsStoreUpdate$)
                    )
            ),
            withLatestFrom(playerPlaybackStoreUpdate$),
            filter(([, { isPlaying }]) => isPlaying),
            map(([, { currentTime }]) => currentTime),
        );

export default createResumePointIntervalStream;
